import { CloseOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import classNames from 'classnames';
import React from 'react';
import { ModalInstanceProps } from '../interfaces';
import { ModalFooter, ModalHeader } from '../modal-helpers';
import styles from './ConfirmDeleteModal.module.css';

type Props = ModalInstanceProps & {
  headerText: string;
  newStyle?: boolean;
  deleteCallback: () => any;
  deleteButtonName?: string;
  description?: string;
};

const ConfirmDeleteModal = (props: Props) => {
  const {
    headerText,
    deleteCallback,
    closeModal,
    newStyle,
    deleteButtonName = 'Delete',
    description,
  } = props;

  const onClickDelete = () => {
    deleteCallback();
    closeModal();
  };

  if (newStyle) {
    return (
      <div className={classNames(styles.newStyle, styles.modal)}>
        <CloseOutlined className={styles.closeIcon} onClick={closeModal} />
        <div className={styles.header}>
          <div>{headerText}</div>
          {description && (
            <div className={styles.description}>{description}</div>
          )}
        </div>
        <div className={styles.footer}>
          <Button
            color="secondary"
            onClick={closeModal}
            css={{ container: styles.secondaryButton }}
          >
            Cancel
          </Button>
          <Button
            color="red"
            onClick={onClickDelete}
            css={{ container: styles.primaryButton }}
          >
            {deleteButtonName}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.modal}>
      <ModalHeader className={styles.header}>{headerText}</ModalHeader>

      <ModalFooter className={styles.footer}>
        <Button color="secondary" size="lg" onClick={closeModal}>
          Cancel
        </Button>

        <Button color="red" size="lg" onClick={onClickDelete}>
          Delete
        </Button>
      </ModalFooter>
    </div>
  );
};

export { ConfirmDeleteModal };
